// extracted by mini-css-extract-plugin
export default {"pill":"pill_pill__tT5yr","pillBg":"pill_pillBg__ouwy5"};